import { useRollbarPerson } from '@rollbar/react';
import { ReactNode } from 'react';

import { useUser } from '@/features/auth';

const RollbarWrapper = ({ children }: { children: ReactNode }) => {
  const { data: user } = useUser();

  useRollbarPerson({
    id: user?.id,
    isLoggedBehalfToits: user?.isLoggedBehalfToits,
    fullName: user?.fullName,
  });

  return <>{children}</>;
};

export default RollbarWrapper;
